module.exports = __webpack_public_path__ + "img/banner_Qualitycontrol.31afb079.jpg";